import React, { useContext } from 'react'
import config from 'config'

import withView from 'core/components/withView'
import useFetch from 'core/hooks/use-fetch'
import { GlobalContext } from 'core/contexts/global-context'
import { getPostBackgrounds } from 'core/helpers/wp-data-helpers'

import Logo from 'core/components/Logo'

const Home = props => {
  const global = useContext(GlobalContext)

  const { loading, error, data } = useFetch('/page/home', {
    onSuccess: data => global.setBackground(getPostBackgrounds(data))
  })

  return (
    <article className={`${props.className} home-page`}>
      <Logo />
      <h1 className="home-title type-heading mod-xxl-head">
        Don't hire us. <span>Join us.</span>
      </h1>
    </article>
  )
}

export default withView(Home)
